import {PermissionAction, ResourceName} from "../features/auth/types";

export const PERMISSION_ACTIONS = ['index' , 'show' , 'create' , 'update', 'destroy'] as const
export const RESOURCES = ['Draft' , 'Creation', 'MediabankResource', 'Emission', 'Impression', 'VoohPlaylist', 'VoohPlaylistExternal'] as const
export const RESOURCE_PATHS: {
    [key in string]: {
        [key: string]: string
    }
} = {
    ['Draft']: {
        index: '/',
        create: '/new-draft',
    },
    ['Creation']: {
        index: '/creations',
        create: '/new-creation',
    },
    ['MediabankResource']: {
        index: '/mediabank-resource',
    },
    ['Emission']: {
        index: '/emissions',
    },
    ['Impression']: {
        index: '/reports',
    },
    ['MediumAccessManagement']: {
        update: '/access-management/mediums',
    },
    // vOOH list/form routes are shared between internal and external types, so they
    // are gated in-component (tabs/actions) rather than via path-based blocking.
    ['VoohPlaylist']: {},
    ['VoohPlaylistExternal']: {},
}
